/* ============================================================
   THE MUSA WORLD v2 — real artifacts, ported copy
   Live product photography floats as luminous exhibits
   in a matte black hall. All wording ported from
   themusafamily.com.
   ============================================================ */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
gsap.registerPlugin(ScrollTrigger);

/* ---------- LIVE PRODUCT DATA (from themusafamily.com) ---------- */
const CDN = 'https://themusafamily.com/cdn/shop/files/';
const PRODUCTS = [
  { title:'MUSA FAMILY VALUES embroidered oversized hoodie', price:'From $59.99 USD',
    url:'https://themusafamily.com/products/musa-family-values-embroidered-oversized-hoodie',
    img: CDN+'unisex-oversized-hoodie-black-front-680d1a36da354.jpg?v=1745689148&width=800' },
  { title:'MUSA FAMILY VALUES embroidered logo tee', price:'From $35.99 USD',
    url:'https://themusafamily.com/products/musa-family-values-embroidered-logo-tee',
    img: CDN+'mens-champion-t-shirt-black-front-680d1cf8857c9.jpg?v=1745689853&width=800' },
  { title:'MUSA FAMILY VALUES embroidered corduroy hat', price:'$35.99 USD',
    url:'https://themusafamily.com/products/musa-family-values-embroidered-corduroy-hat',
    img: CDN+'vintage-corduroy-cap-black-front-6814579a32e2b.jpg?v=1746163620&width=800' },
];

/* ---------- Generate chapter DOM from product data ---------- */
const artifactsRoot = document.getElementById('artifacts');
PRODUCTS.forEach((p, i) => {
  const side = i % 2 === 0 ? '' : ' right';
  const sec = document.createElement('section');
  sec.className = 'chapter' + side;
  sec.id = 'artifact-' + i;
  sec.innerHTML = `
    <div class="panel">
      <div class="ch-index reveal"><span>Artifact ${String(i+1).padStart(2,'0')} / ${String(PRODUCTS.length).padStart(2,'0')}</span><span class="rule"></span></div>
      <h2 class="ch-title reveal">${p.title}</h2>
      <div class="ch-price reveal">${p.price}</div>
      <a class="ch-cta reveal" href="${p.url}" target="_blank" rel="noopener">View Artifact <span class="arrow">→</span></a>
    </div>`;
  artifactsRoot.appendChild(sec);
});

/* ---------- Lenis buttery scroll (graceful fallback) ---------- */
let lenis = null;
if (!reduceMotion && typeof Lenis !== 'undefined') {
  lenis = new Lenis({ lerp: 0.085, smoothWheel: true });
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => lenis.raf(time * 1000));
  gsap.ticker.lagSmoothing(0);
}

/* ---------- Renderer / scene ---------- */
const canvas = document.getElementById('gl');
const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: false });
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.75));
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1.12;

const scene = new THREE.Scene();
scene.background = new THREE.Color(0x0a0a0a);
scene.fog = new THREE.FogExp2(0x0a0a0a, 0.05);

const camera = new THREE.PerspectiveCamera(42, window.innerWidth/window.innerHeight, 0.1, 260);
camera.position.set(0, 0.4, 10);

/* ---------- Lighting ---------- */
scene.add(new THREE.HemisphereLight(0x2a2a2a, 0x050505, 0.7));
const key = new THREE.DirectionalLight(0xf5f5f5, 0.8);
key.position.set(4, 6, 6); scene.add(key);
const rim = new THREE.DirectionalLight(0xf5f5f5, 1.4);
rim.position.set(-6, 3, -8); scene.add(rim);
const follow = new THREE.PointLight(0xffffff, 1.0, 22, 2);
scene.add(follow);

/* ---------- Materials ---------- */
const matte = new THREE.MeshPhysicalMaterial({
  color: 0x151515, roughness: 0.88, metalness: 0.12,
  clearcoat: 0.35, clearcoatRoughness: 0.7
});
const matteDeep = new THREE.MeshPhysicalMaterial({
  color: 0x0e0e0e, roughness: 0.95, metalness: 0.05,
  clearcoat: 0.2, clearcoatRoughness: 0.9
});

/* ---------- Heirwave light texture ---------- */
const HW_P1 = "M 409.22 581.23 C 431.01 544.52 457.46 513.04 486.65 480.40 C 511.81 452.27 539.03 429.05 573.06 412.87 C 601.81 399.20 632.08 394.30 663.88 398.17 C 689.29 401.26 712.87 408.73 734.62 420.58 C 735.15 420.87 735.29 420.74 735.04 420.19 C 734.71 419.46 734.21 418.47 733.54 417.21 C 720.25 392.39 703.73 370.82 681.24 354.61 C 636.99 322.71 579.95 325.48 535.13 354.36 C 525.31 360.69 515.70 367.33 506.30 374.27 C 499.25 379.47 493.66 383.00 489.51 384.85 C 455.28 400.19 433.99 368.46 423.30 341.98 C 423.19 341.71 422.80 341.72 422.70 341.99 C 409.98 376.24 393.75 408.67 374.00 439.28 C 348.81 478.32 313.17 515.01 265.54 524.57 C 247.66 528.16 229.56 528.93 211.25 526.90 C 209.30 526.69 207.31 526.54 205.26 526.45 C 204.94 526.44 204.70 526.73 204.77 527.04 C 206.96 536.19 210.42 546.40 215.17 557.66 C 215.45 558.32 215.71 558.84 215.95 559.21 C 216.21 559.63 216.67 559.89 217.34 559.98 C 251.25 564.81 284.45 559.28 315.71 545.43 C 337.28 535.87 357.51 524.03 376.41 509.90 C 399.06 492.97 421.50 475.59 443.75 457.78 C 444.11 457.49 444.62 457.88 444.43 458.30 C 434.83 479.91 422.74 500.37 408.89 519.58 C 389.16 546.93 361.45 573.94 331.71 589.22 C 304.51 603.19 275.66 608.56 245.17 605.31 C 244.79 605.27 244.53 605.69 244.74 606.01 C 252.29 617.67 261.04 628.25 271.00 637.75 C 290.86 656.69 314.53 667.52 342.02 670.25 C 392.20 675.23 434.79 647.48 471.84 617.57 C 484.00 607.75 496.19 597.99 508.13 587.89 C 545.82 556.03 589.86 526.93 636.30 510.35 C 669.33 498.56 703.53 495.45 738.92 501.02 C 764.79 505.09 787.94 514.79 808.37 530.11 C 809.24 530.76 809.52 530.57 809.21 529.53 C 801.59 504.17 787.61 483.31 767.27 466.96 C 745.17 449.19 720.08 437.92 691.99 433.13 C 650.69 426.08 609.77 436.18 574.00 457.02 C 542.68 475.27 513.69 497.96 486.12 521.39 C 461.43 542.38 436.65 563.52 409.54 581.54 C 409.34 581.67 409.10 581.44 409.22 581.23 Z";
const HW_P2 = "M 706.74 554.09 C 740.01 549.91 776.76 554.53 807.12 569.89 C 807.41 570.04 807.56 570.37 807.48 570.68 C 794.06 623.73 756.43 663.86 700.24 669.37 C 649.64 674.34 611.18 649.17 584.47 608.10 C 584.38 607.90 584.34 607.63 584.58 607.48 C 620.35 581.03 661.73 559.75 706.74 554.09 Z";

/* Official Heirwave texture — the real vector paths drawn on a
   padded transparent canvas. Logo bounds in the 1024 viewBox are
   ~x:156-856, y:320-680. We draw with a margin larger than the
   glow blur so nothing is ever clipped — no edges, no rectangles. */
const HW_CANVAS = { w: 1360, h: 1040, pad: 180 }; // 700x360 mark + 180px margin, x2 scale
function heirwaveTexture(glowBlur) {
  const c = document.createElement('canvas');
  c.width = HW_CANVAS.w; c.height = HW_CANVAS.h;
  const x = c.getContext('2d');
  /* map viewBox mark bounds (156,320)-(856,680) into padded canvas */
  const scale = (HW_CANVAS.w - HW_CANVAS.pad * 2) / 700;
  x.translate(HW_CANVAS.pad, HW_CANVAS.h / 2 - (500 - 320) * scale); // vertical center on mark middle (y≈500)
  x.scale(scale, scale);
  x.translate(-156, -320);
  if (glowBlur) { x.shadowColor = '#f5f5f5'; x.shadowBlur = glowBlur; }
  x.fillStyle = '#f5f5f5';
  x.fill(new Path2D(HW_P1));
  x.fill(new Path2D(HW_P2));
  const t = new THREE.CanvasTexture(c);
  t.anisotropy = 8;
  return t;
}
const hwTexSoft  = heirwaveTexture(60);  // glowing — heroes, satellites
const hwTexCrisp = heirwaveTexture(0);   // clean — stamps

function makeHeirwavePlane(size, opacity, crisp) {
  const m = new THREE.MeshBasicMaterial({
    map: crisp ? hwTexCrisp : hwTexSoft,
    transparent: true, opacity,
    side: THREE.DoubleSide, depthWrite: false,
    blending: THREE.AdditiveBlending
  });
  const mesh = new THREE.Mesh(
    new THREE.PlaneGeometry(size, size * HW_CANVAS.h / HW_CANVAS.w), m);
  mesh.userData.mats = [m];
  return mesh;
}

/* ---------- Environment ---------- */
const world = new THREE.Group();
scene.add(world);

const HALL_END = -14 - (PRODUCTS.length - 1) * 10; // last exhibit z

const floor = new THREE.Mesh(new THREE.PlaneGeometry(320, 320), matteDeep);
floor.rotation.x = -Math.PI/2; floor.position.y = -3.2; floor.position.z = -80;
world.add(floor);
const ceil = floor.clone();
ceil.rotation.x = Math.PI/2; ceil.position.y = 9;
world.add(ceil);

/* monolith columns lining the hall */
for (let i = 0; i < 22; i++) {
  const h = 9 + Math.random()*4;
  const col = new THREE.Mesh(new THREE.BoxGeometry(0.9, h, 0.9), i % 3 === 0 ? matte : matteDeep);
  const side = i % 2 === 0 ? -1 : 1;
  col.position.set(side * (6 + Math.random()*4), -3.2 + h/2, -4 - i*5.2);
  col.rotation.y = Math.random()*0.4;
  world.add(col);
}

/* portal rings between exhibits */
const ringGeo = new THREE.TorusGeometry(5.4, 0.07, 16, 120);
for (let z = -19; z > HALL_END; z -= 20) {
  const ring = new THREE.Mesh(ringGeo, matte);
  ring.position.set(0, 0.5, z);
  ring.rotation.x = 0.06;
  ring.userData.spin = (z/20 % 2 ? -1 : 1) * 0.0009;
  world.add(ring);
}

/* dust */
const COUNT = window.innerWidth < 720 ? 320 : 700;
const dustPos = new Float32Array(COUNT * 3);
for (let i = 0; i < COUNT; i++) {
  dustPos[i*3]   = (Math.random()-0.5) * 26;
  dustPos[i*3+1] = (Math.random()-0.5) * 14;
  dustPos[i*3+2] = HALL_END - 20 + Math.random() * (Math.abs(HALL_END) + 34);
}
const dustGeo = new THREE.BufferGeometry();
dustGeo.setAttribute('position', new THREE.BufferAttribute(dustPos, 3));
const dust = new THREE.Points(dustGeo, new THREE.PointsMaterial({
  color: 0xf5f5f5, size: 0.022, transparent: true, opacity: 0.5,
  blending: THREE.AdditiveBlending, depthWrite: false
}));
world.add(dust);

/* ============================================================
   The world's Heirwaves — official mark only ----------
   Every Heirwave in the scene is the real vector, drawn with a
   fully-padded glow. Clean by construction. */

/* hero — the official vector mark, same texture used throughout
   the scene. No raster source, so it can never look distorted. */
const heroWave = makeHeirwavePlane(11, 0.95, false);
heroWave.position.set(0, 0.7, -6);
world.add(heroWave);
const heroWaveEcho = makeHeirwavePlane(19, 0.12);
heroWaveEcho.position.set(0, 0.7, -12);
world.add(heroWaveEcho);

/* final monument at the end of the hall */
const finalWave = makeHeirwavePlane(15, 0.45);
finalWave.position.set(0, 1.2, HALL_END - 22);
world.add(finalWave);

/* ============================================================
   EXHIBITS — real product photography, backgrounds keyed out
   in the browser so the garments float free in the fog.
   No slabs. No frames. No boxes.
   ============================================================ */

/* white-background keyer: near-white, low-saturation pixels
   become transparent with a soft feathered edge */
function keyedTexture(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const c = document.createElement('canvas');
        c.width = img.width; c.height = img.height;
        const x = c.getContext('2d');
        x.drawImage(img, 0, 0);
        const d = x.getImageData(0, 0, c.width, c.height);
        const px = d.data;
        const HARD = 240, SOFT = 220; // tight feather band close to true white
        const FLOOR = 46; // below this alpha, snap fully transparent — no translucent haze
        for (let i = 0; i < px.length; i += 4) {
          const r = px[i], gg = px[i+1], b = px[i+2];
          const mx = Math.max(r, gg, b), mn = Math.min(r, gg, b);
          const sat = mx - mn;
          if (sat < 28) {
            if (mx >= HARD) px[i+3] = 0;
            else if (mx > SOFT) {
              const k = 1 - (mx - SOFT) / (HARD - SOFT);
              const a = px[i+3] * k;
              px[i+3] = a < FLOOR ? 0 : Math.round(a);
            }
          }
        }
        /* choke pass — kill any residual partial-alpha fringe that
           touches fully-transparent background, so garment edges
           cut clean with no whitish halo */
        const w = c.width, h = c.height;
        const a0 = new Uint8ClampedArray(w * h);
        for (let i = 0, j = 0; i < px.length; i += 4, j++) a0[j] = px[i+3];
        for (let yy = 0; yy < h; yy++) {
          for (let xx = 0; xx < w; xx++) {
            const idx = yy * w + xx;
            const av = a0[idx];
            if (av === 0 || av === 255) continue;
            const left  = xx > 0     ? a0[idx-1] : 0;
            const right = xx < w - 1 ? a0[idx+1] : 0;
            const up    = yy > 0     ? a0[idx-w] : 0;
            const down  = yy < h - 1 ? a0[idx+w] : 0;
            if (left === 0 || right === 0 || up === 0 || down === 0) {
              px[idx * 4 + 3] = 0;
            }
          }
        }
        x.putImageData(d, 0, 0);
        const t = new THREE.CanvasTexture(c);
        t.encoding = THREE.sRGBEncoding;
        t.anisotropy = 4;
        resolve({ tex: t, aspect: img.width / img.height });
      } catch (e) {
        const t = new THREE.Texture(img);
        t.needsUpdate = true;
        t.encoding = THREE.sRGBEncoding;
        resolve({ tex: t, aspect: img.width / img.height, raw: true });
      }
    };
    img.onerror = reject;
    img.src = src;
  });
}

const exhibits = [];
PRODUCTS.forEach((p, i) => {
  const side = i % 2 === 0 ? 1 : -1;       // exhibit opposite the caption
  const z = -14 - i * 10;
  const g = new THREE.Group();
  g.position.set(side * 1.9, 0.45, z);
  g.rotation.y = -side * 0.42;

  const W = 2.7;

  /* the garment — a free-floating keyed photograph */
  const photoMat = new THREE.MeshBasicMaterial({
    transparent: true, opacity: 0,
    depthWrite: false, side: THREE.DoubleSide
  });
  const photo = new THREE.Mesh(new THREE.PlaneGeometry(W, W), photoMat);
  g.add(photo);

  keyedTexture(p.img).then(({ tex, aspect }) => {
    photoMat.map = tex;
    photoMat.needsUpdate = true;
    if (aspect > 1) photo.scale.set(1, 1/aspect, 1);
    else if (aspect < 1) photo.scale.set(aspect, 1, 1);
    gsap.to(photoMat, { opacity: 1, duration: 1.4, ease: 'power2.out' });
  }).catch(() => {
    /* image failed entirely — float a Heirwave in its place */
    const stamp = makeHeirwavePlane(1.8, 0.85);
    g.add(stamp);
  });

  /* mono index line floating beneath — pure text, no plate */
  const placard = new THREE.Mesh(
    new THREE.PlaneGeometry(1.5, 0.14),
    new THREE.MeshBasicMaterial({
      map: textTex('ARTIFACT ' + String(i+1).padStart(2,'0')),
      transparent: true, opacity: 0.65,
      depthWrite: false, blending: THREE.AdditiveBlending
    })
  );
  placard.position.set(0, -(W/2) - 0.35, 0.05);
  g.add(placard);

  /* small orbiting heirwave */
  const sat = makeHeirwavePlane(1.2, 0.2);
  world.add(sat);

  world.add(g);
  exhibits.push({ group: g, sat, baseY: g.position.y, phase: Math.random()*Math.PI*2, z, side });
});
function textTex(str) {
  const c = document.createElement('canvas'); c.width = 768; c.height = 72;
  const x = c.getContext('2d');
  x.fillStyle = 'rgba(230,193,77,0.92)';
  x.font = '300 34px "IBM Plex Mono", monospace';
  x.textAlign = 'center'; x.textBaseline = 'middle';
  try { x.letterSpacing = '14px'; } catch(e) {}
  x.fillText(str, 384, 38);
  const t = new THREE.CanvasTexture(c);
  return t;
}

/* ============================================================
   CINEMATIC SCROLL — dolly synced to section heights
   ============================================================ */
const cam = { z: 10, y: 0.4, x: 0, lookX: 0, lookY: 0.4, fog: 0.05 };
const mouse = { x: 0, y: 0 };
window.addEventListener('pointermove', e => {
  mouse.x = (e.clientX / window.innerWidth - 0.5);
  mouse.y = (e.clientY / window.innerHeight - 0.5);
}, { passive: true });

/* build the master dolly with durations proportional to section heights:
   hero(100) intro(120) → products(130 each) → purpose(120+110+110+110+110) family(130) join(110) */
const master = gsap.timeline({
  scrollTrigger: {
    trigger: 'main', start: 'top top', end: 'bottom bottom',
    scrub: reduceMotion ? false : 1.4
  }
});

let t = 0;
master.to(cam, { z: 3, ease: 'none', duration: 1.0 }, t); t += 1.0;          // hero drift
master.to(cam, { z: -4, ease: 'none', duration: 1.2 }, t); t += 1.2;         // intro line
exhibits.forEach((ex) => {                                                    // one beat per artifact
  master.to(cam, {
    z: ex.z + 4.6,
    x: -ex.side * 0.5,
    lookX: ex.side * 1.9, lookY: 0.55,
    ease: 'none', duration: 1.3
  }, t);
  master.to(ex.group.rotation, { y: -ex.side * 0.5, ease: 'none', duration: 1.3 }, t);
  t += 1.3;
});
/* purpose — the hall opens */
master.to(cam, { z: HALL_END - 4, x: 0, lookX: 0, lookY: 0.8, fog: 0.038, ease: 'none', duration: 1.2 }, t); t += 1.2;
master.to(cam, { z: HALL_END - 8,  ease: 'none', duration: 1.1 }, t); t += 1.1;
master.to(cam, { z: HALL_END - 11, ease: 'none', duration: 1.1 }, t); t += 1.1;
master.to(cam, { z: HALL_END - 14, ease: 'none', duration: 1.1 }, t); t += 1.1;
master.to(cam, { z: HALL_END - 16, lookY: 1.1, ease: 'none', duration: 1.1 }, t); t += 1.1; // SPREAD WEALTH
master.to(cam, { z: HALL_END - 17.5, ease: 'none', duration: 1.3 }, t); t += 1.3;           // family
master.to(cam, { z: HALL_END - 18.5, lookY: 1.2, ease: 'none', duration: 1.1 }, t);         // join, facing final wave
finalWave.userData.mats.forEach(m => master.to(m, { opacity: Math.min(m.opacity + 0.35, 1), ease: 'none', duration: 2 }, t - 1));
heroWave.userData.mats.forEach(m => master.to(m, { opacity: 0, ease: 'none', duration: 0.8 }, 0.5));

/* ---------- DOM choreography ---------- */
if (!reduceMotion) {
  gsap.to('.hero h1 .row span', { y: 0, duration: 1.4, ease: 'power4.out', stagger: 0.14, delay: 0.25 });
  gsap.to('.hero .sub', { opacity: 1, duration: 1.6, ease: 'power2.out', delay: 1.1 });
} else {
  gsap.set('.hero h1 .row span', { y: 0 });
  gsap.set('.hero .sub', { opacity: 1 });
}

gsap.to('.hero', {
  opacity: 0, y: -80, ease: 'none',
  scrollTrigger: { trigger: '.hero', start: 'top top', end: '80% top', scrub: true }
});

document.querySelectorAll('.chapter, .purpose-block, .family').forEach(sec => {
  gsap.to(sec.querySelectorAll('.reveal'), {
    opacity: 1, y: 0, duration: 1.1, ease: 'power3.out', stagger: 0.12,
    scrollTrigger: { trigger: sec, start: 'top 55%', toggleActions: 'play none none reverse' }
  });
});

document.querySelectorAll('[data-interlude]').forEach(sec => {
  gsap.fromTo(sec, { opacity: 0 }, {
    opacity: 1, ease: 'none',
    scrollTrigger: { trigger: sec, start: 'top 75%', end: 'top 30%', scrub: true }
  });
  gsap.to(sec, {
    opacity: 0, ease: 'none',
    scrollTrigger: { trigger: sec, start: 'bottom 65%', end: 'bottom 25%', scrub: true }
  });
});

/* purpose headline — word by word ignition (ported line) */
const LINE = 'We did not build a brand. We were given a name to carry.';
const holder = document.getElementById('purpose-line');
LINE.split(' ').forEach(w => {
  const span = document.createElement('span');
  span.className = 'w'; span.textContent = w;
  holder.appendChild(span);
  holder.appendChild(document.createTextNode(' '));
});
ScrollTrigger.create({
  trigger: '.purpose-hero', start: 'top 60%', end: 'center 40%', scrub: true,
  onUpdate: self => {
    const ws = holder.querySelectorAll('.w');
    const lit = Math.floor(self.progress * ws.length);
    ws.forEach((w, i) => w.style.opacity = (reduceMotion || i <= lit) ? 1 : 0.12);
  }
});

gsap.to('#progress', {
  scaleX: 1, ease: 'none',
  scrollTrigger: { trigger: 'main', start: 'top top', end: 'bottom bottom', scrub: true }
});
ScrollTrigger.create({
  start: 'top -60',
  onEnter: () => document.getElementById('hint').classList.add('gone'),
  onLeaveBack: () => document.getElementById('hint').classList.remove('gone')
});

/* ---------- Render loop ---------- */
const clock = new THREE.Clock();
function tickFrame() {
  const tt = clock.getElapsedTime();

  camera.position.z = cam.z;
  camera.position.x = cam.x + mouse.x * 0.55;
  camera.position.y = cam.y - mouse.y * 0.35 + (reduceMotion ? 0 : Math.sin(tt * 0.5) * 0.05);
  camera.lookAt(cam.lookX + mouse.x * 0.7, cam.lookY - mouse.y * 0.35, camera.position.z - 6);
  scene.fog.density = cam.fog;
  follow.position.set(camera.position.x, camera.position.y + 1.2, camera.position.z - 4);

  if (!reduceMotion) {
    exhibits.forEach((ex, i) => {
      ex.group.position.y = ex.baseY + Math.sin(tt * 0.7 + ex.phase) * 0.09;
      ex.group.rotation.z = Math.sin(tt * 0.4 + ex.phase) * 0.015;
      ex.sat.position.set(
        ex.group.position.x + Math.cos(tt * 0.3 + ex.phase) * 2.2,
        ex.group.position.y + 1.5 + Math.sin(tt * 0.5 + ex.phase) * 0.25,
        ex.z + Math.sin(tt * 0.3 + ex.phase) * 1.4
      );
      ex.sat.lookAt(camera.position);
    });

    heroWave.rotation.z = Math.sin(tt * 0.2) * 0.02;
    heroWave.position.y = 0.7 + Math.sin(tt * 0.6) * 0.08;
    finalWave.position.y = 1.2 + Math.sin(tt * 0.5) * 0.1;

    const p = dust.geometry.attributes.position;
    for (let i = 0; i < COUNT; i++) {
      p.array[i*3+1] += 0.0022;
      if (p.array[i*3+1] > 7) p.array[i*3+1] = -7;
    }
    p.needsUpdate = true;

    world.children.forEach(ch => { if (ch.userData.spin) ch.rotation.z += ch.userData.spin; });
  }

  renderer.render(scene, camera);
  requestAnimationFrame(tickFrame);
}
tickFrame();

window.addEventListener('resize', () => {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
});
